(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sense-direction]');
    if (!button) return;
    const gallery = button.closest('media-gallery.sense-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    const rail = gallery.querySelector('[id^="Slider-Thumbnails-"]');
    if (!rail) return;
    const thumbnails = Array.from(rail.querySelectorAll('[data-target]')).filter(
      (item) => getComputedStyle(item).display !== 'none'
    );
    if (thumbnails.length < 2) return;
    const current = thumbnails.findIndex((item) => item.querySelector('[aria-current="true"]'));
    const next = (Math.max(current, 0) + Number(button.dataset.senseDirection) + thumbnails.length) % thumbnails.length;
    const target = thumbnails[next];
    gallery.setActiveMedia(target.dataset.target, false);
    const itemTop = target.getBoundingClientRect().top - rail.getBoundingClientRect().top + rail.scrollTop;
    if (itemTop < rail.scrollTop) rail.scrollTop = itemTop;
    else if (itemTop + target.offsetHeight > rail.scrollTop + rail.clientHeight) {
      rail.scrollTop = itemTop + target.offsetHeight - rail.clientHeight;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
